export const MICROAPPFAKEDATABASE = {
    microappSecurityTree: {
        'users': {
            'access': {
                'USER': true,
                'ADMIN': true,
            }
        }
    }
}